import { Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { FooterComponent } from './sections/footer/footer.component';
import { HeaderComponent } from './sections/header/header.component';
import { isPlatformBrowser } from '@angular/common';

declare let gtag: (...args: any[]) => void;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    FooterComponent,
    HeaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private title = inject(Title);
  private meta = inject(Meta);
  private router = inject(Router);

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.title.setTitle('CloudFusion IT – Exzellenz, die skaliert');
    this.meta.addTags([
      {
        name: 'description',
        content: 'Erstelle moderne, skalierbare Weblösungen mit Angular, Spring Boot, Kubernetes und Azure. Hüseyin Korkut – technischer Macher seit 2012.',
      },
      {
        name: 'keywords',
        content: 'Angular, Full-Stack, Spring Boot, Java, Kubernetes, Docker, Azure, Webentwicklung',
      },
      { name: 'author', content: 'Hüseyin Korkut' },
      { name: 'robots', content: 'index, follow' },
    ]);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (
          typeof gtag === 'function' &&
          document.cookie.includes('analytics:yes')
        ) {
          gtag('config', 'G-54RLRE5SF7', {
            page_path: event.urlAfterRedirects,
          });
        }
        
      }
    });
  }

}
